module.exports = __webpack_public_path__ + "static/media/36_B.d363b42b.png";